<template>
    <div class="authentication-wrapper">
        <div v-if="$route.query.disconnected" class="banner">
            You have been disconnected. Please reconnect in order to access your account
        </div>
        <div v-else-if="$route.query.deleted" class="banner">
            Your account has been deleted.
        </div>
        <div v-else-if="$route.query.expired" class="banner">
            Your token has expired. Please log in again or request a lost password.
        </div>
        <div class="layout">
            <header>
                <div class="brand">
                    <svg-logo />
                </div>
            </header>
            <main>
                <router-view />
            </main>
        </div>
    </div>
</template>

<script>
import SvgLogo from '@/assets/images/logo.svg'
export default {
    components: { SvgLogo }
}
</script>
